// This helper function is similar to Element.closest(),
// however it also traverses shadow DOM boundaries.
const closest = (selector, el) => {
    return (el &&
        (('closest' in el && el.closest(selector)) ||
            closest(selector, el.getRootNode().host)));
};

export { closest as c };

//# sourceMappingURL=closest.js.map